<div class="guidelines-page">
  <div class="guidelines-hero">
    <div>
      <div class="eyebrow">EVM KNOWLEDGE BASE</div>
      <h1>SOP / Guidelines</h1>
      <p class="hero-copy">
        Day-to-day EVM operating guidance, shortcuts, do's and don'ts, and project-specific audit criteria.
      </p>
    </div>

    <div class="project-pill">
      <i class="fas fa-building"></i>
      <span>Project / Client</span>
      <strong>{{ activeClientId || 'Not selected' }}</strong>
    </div>
  </div>

  <section class="guideline-section">
    <div class="section-heading">
      <div>
        <div class="section-kicker">TEAM MEMBERS</div>
        <h2>How to use EVM</h2>
        <p>Use these instructions while working patient verification and benefit breakdowns.</p>
      </div>

      <button
        *ngIf="canManageGuidelines"
        type="button"
        class="btn add-guideline-btn"
        (click)="openAddGuideline('TEAM')">
        <i class="fas fa-plus"></i>
        Add Guidelines
      </button>
    </div>

    <div class="guideline-grid">
      <article class="guideline-card" *ngFor="let guideline of teamGuidelines; let i = index">
        <div class="guideline-number">{{ (i + 1) < 10 ? '0' + (i + 1) : (i + 1) }}</div>
        <div>
          <h3>{{ guideline.title }}</h3>
          <p>{{ guideline.description }}</p>
        </div>
      </article>
    </div>
  </section>

  <section class="guideline-section audit-section" *ngIf="canManageGuidelines">
    <div class="section-heading">
      <div>
        <div class="section-kicker audit-kicker">AUDITOR</div>
        <h2>Audit criteria & project guidance</h2>
        <p>
          These audit instructions are restricted to users with the <strong>client-edit</strong> role and are maintained per active project/client.
        </p>
      </div>

      <button
        type="button"
        class="btn add-guideline-btn audit-btn"
        (click)="openAddGuideline('AUDIT')">
        <i class="fas fa-plus"></i>
        Add Guidelines
      </button>
    </div>

    <div class="audit-note">
      <i class="fas fa-shield-alt"></i>
      <div>
        <strong>Project-specific audit governance</strong>
        <span>Always use the questionnaire, category weightage, question weightage and severity configured for the selected client.</span>
      </div>
    </div>

    <div class="guideline-grid">
      <article class="guideline-card audit-card" *ngFor="let guideline of auditGuidelines; let i = index">
        <div class="guideline-number">{{ (i + 1) < 10 ? '0' + (i + 1) : (i + 1) }}</div>
        <div>
          <h3>{{ guideline.title }}</h3>
          <p>{{ guideline.description }}</p>
        </div>
      </article>
    </div>
  </section>
</div>

<div class="guideline-modal-backdrop" *ngIf="showGuidelineModal" (click)="closeGuidelineModal()">
  <div class="guideline-modal" (click)="$event.stopPropagation()">
    <div class="modal-header-row">
      <div>
        <div class="section-kicker">{{ guidelineType === 'AUDIT' ? 'AUDITOR' : 'TEAM MEMBERS' }}</div>
        <h3>Add guideline</h3>
      </div>
      <button type="button" class="modal-close" (click)="closeGuidelineModal()" aria-label="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="form-group">
      <label>Guideline title</label>
      <input
        type="text"
        class="form-control"
        maxlength="120"
        [(ngModel)]="guidelineTitle"
        placeholder="Enter a short guideline title">
    </div>

    <div class="form-group mb-0">
      <label>Guideline details</label>
      <textarea
        class="form-control"
        rows="5"
        maxlength="1000"
        [(ngModel)]="guidelineDescription"
        placeholder="Enter the instruction, criteria or SOP detail"></textarea>
    </div>

    <div class="modal-actions">
      <button type="button" class="btn btn-light" (click)="closeGuidelineModal()">Cancel</button>
      <button
        type="button"
        class="btn add-guideline-btn"
        [disabled]="!guidelineTitle.trim() || !guidelineDescription.trim()"
        (click)="addGuideline()">
        Save Guideline
      </button>
    </div>
  </div>
</div>
